import React, { useState, useCallback, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { Formik } from "formik";
import * as Yup from "yup";

import * as commonApi from "../../api/commonApi"
import { isEmptyObject, isEmptyArray } from "../../util"
import { Common, SUCCESS } from "../../helper"
import { success } from "../Shared";

import UploadEvidenceImg from "../../assets/images/uploadEvidence.png";
import AttachFileImg from "../../assets/images/attach_file_add.png";
import RemoveImg from "../../assets/images/IconRemove.png";
import SaveButton from "../../assets/images/SaveButton.png"

const UploadEvidences = (props) => {
  const { setIsOpen, classId, setIsStudentPage } = props
  const [isUploadPage, setUploadPage] = useState(false);
  const [isSubjectPage, setSubjectPage] = useState(true);
  const [isStudentList, setStudentList] = useState(false);
  const [isStudentModal, setIsStudentModal] = useState(false);
  const [selectedPupilIds, setSelectedPupilIds] = useState([]);

  const [subjectList, setSubjectList] = useState();
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectErr, setSubjectErr] = useState(false)

  const [uploadErr, setUploadErr] = useState(false);
  const [pupilErr, setPupilErr] = useState(false);

  const [pupilList, setPupilList] = useState();

  const [files, setFiles] = useState([]);

  const onDrop = useCallback(acceptedFiles => {
    setFiles([...files, ...acceptedFiles]);
  }, [files]);

  const removeFile = index => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
  };

  const fileItems = files.map((file, index) => (
    <>
      {index === 0 ? <span>{Common.CurrentEvidence}</span> : null}
      <div key={index} className="evidence-items">
        <span>{file.name}</span>
        <div>
          <button onClick={() => removeFile(index)} className="remove-button"> <img src={RemoveImg} alt="RemoveImg" /> <span>{Common.Remove}</span></button>
        </div>
      </div>
      <hr />
    </>
  ));

  const getClassPupil = async () => {
    const allPupileList = await commonApi.viewStudents({ id: classId });
    if (!isEmptyArray(allPupileList.Items)) {
      setPupilList(allPupileList.Items);
    }
  }

  const getSubjects = async () => {
    const classSubjects = await commonApi.getSubjectByClass({ classId: classId });
    if (!isEmptyArray(classSubjects.Items)) {
      setSubjectList(classSubjects.Items);
    }
  }

  const selectAllPupils = (event) => {
    setSelectedPupilIds([]);
    if (event.target.checked === true) {
      const data = [...pupilList];
      const pupilIds = pupilList?.map((item) => item.id);
      setSelectedPupilIds(pupilIds);
      setPupilList(data);
    } else {
      const data = [...pupilList];
      setSelectedPupilIds([]);
      setPupilList(data);
    }
  }

  const getPupilId = (event) => {
    var data = [...selectedPupilIds];
    var pupilData = [...pupilList];
    if (event.target.checked === true) {
      data.push(event.target.value);
      setSelectedPupilIds(data);
      setPupilList(pupilData);
    } else {
      const newArray = selectedPupilIds.filter(item => item !== event.target.value);
      setSelectedPupilIds(newArray);
      setPupilList(pupilData);
    }
  }

  const uploadValidation = () => {
    if (isEmptyArray(files)) {
      setUploadErr(true);
    } else {
      setUploadErr(false);
      setStudentList(true);
    }
  }

  const subjectValidation = () => {
    if (!isEmptyArray(selectedSubjects)) {
      setUploadPage(true);
      setSubjectPage(false);
      setSubjectErr(false);
    } else {
      setSubjectErr(true);
    }
  }

  const getSubjectsValue = (event) => {
    var data = [...selectedSubjects];
    var subjectData = [...subjectList];
    if (selectedSubjects.includes(event.target.value)) {
      const newArray = selectedSubjects.filter(item => item !== event.target.value);
      setSelectedSubjects(newArray);
      setSubjectList(subjectData);
    } else {
      data.push(event.target.value);
      setSelectedSubjects(data);
      setSubjectList(subjectData);
    }
  }

  useEffect(() => {
    getClassPupil();
    getSubjects();
  }, [])

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <React.Fragment>
      <Formik
        initialValues={{}}
        validationSchema={Yup.object().shape()}
        onSubmit={async () => {
          if (isEmptyArray(selectedPupilIds)) {
            setPupilErr(true);
          } else {
            const filesPaths = files.map(item => (item.path));
            const formData = {
              classId: classId,
              evidences: filesPaths,
              pupilIds: selectedPupilIds,
              subsubject: selectedSubjects
            }

            const singedUrls = await commonApi.uploadEvidence(formData);
            if (!isEmptyObject(singedUrls)) {
              let uploadParams = singedUrls.Items;
              if (Array.isArray(uploadParams)) {
                for (let index = 0; index < uploadParams.length; index++) {
                  if (index + 1 === uploadParams.length) {
                    setIsOpen(false)
                    success(SUCCESS.FILES_UPLOADED)
                  }
                }
              }
            }
          }
        }}
      >
        {({ handleSubmit }) => (
          <form noValidate onSubmit={handleSubmit}>
            {
              isSubjectPage && (
                <div>
                  <div className="form-group mb-3" style={{ display: "flex", flexDirection: "row", gap: "25px" }}>
                    <div className="d-flex" style={{ gap: "8px" }}>
                      {
                        subjectList && subjectList.map((item) => {
                          return (
                            <>
                              <Form.Check
                                type={"radio"}
                                value={item.id}
                                onClick={(e) => { getSubjectsValue(e); setSubjectErr(false) }}
                                checked={selectedSubjects.includes(item.id)}
                              />
                              <label className="radio-text" >{item.subjectName}</label>
                            </>
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button className="upload-next" type="button" onClick={() => { subjectValidation() }}>{Common.Next}</button>&nbsp;
                    <button className="upload-cancel" type="button" onClick={() => setIsOpen(false)}>{Common.Cancel}</button>
                  </div>
                  {subjectErr && (<small className="d-flex justify-content-between text-danger">{Common.PleaseSelectSubject}</small>)}
                </div>
              )
            }
            {
              isUploadPage && (
                <div>
                  <div>
                    <div {...getRootProps()} className="dropzone">
                      <input {...getInputProps()} />

                      <p> <img className="img" src={AttachFileImg} alt="AttachFileImg" />{Common.DragFiles}</p>
                    </div>
                    <div className="horizontal-line" />
                    {
                      isStudentList && (
                        <div className="file-list">
                          <div></div>
                          {fileItems}
                        </div>
                      )
                    }
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <button className="upload-cancel" type="button" onClick={() => { setUploadPage(!isUploadPage); setSubjectPage(true); setUploadErr(false) }}>{Common.Back}</button>&nbsp;
                    </div>
                    <div>
                      {!isStudentList && <button className="upload-button" type="button" onClick={() => uploadValidation()}>
                        <div className="d-flex justify-content-between ">
                          <span>{Common.Upload}</span>
                          <img src={UploadEvidenceImg} alt="UploadEvidenceImg" />
                        </div>
                      </button>}
                      {isStudentList && (
                        <button className="add-student" type="button" onClick={() => { setIsStudentModal(true); setIsStudentPage(true); setUploadPage(false) }}>
                          <div className="d-flex justify-content-between">
                            <span className="add-button">{Common.AddStudents} <span className="pluse-symbole">+</span></span>
                          </div>
                        </button>
                      )
                      }&nbsp;
                      <button className="upload-cancel" type="button" onClick={() => setIsOpen(false)}>{Common.Cancel}</button>
                    </div>
                  </div>
                  <br />
                  {uploadErr && (<small className="d-flex justify-content-between text-danger">{Common.PleaseUploadFiles}</small>)}
                </div>
              )
            }
            {
              isStudentModal && (
                <div>
                  {pupilList && pupilList.map((item, i) => {
                    return (
                      <>
                        {i === 0 && (
                          <div>
                            <div>
                              <div className="d-flex justify-content-between">
                                <span>
                                  <input type="checkbox" onClick={(e) => { selectAllPupils(e); setPupilErr(false) }} checked={pupilList.length === selectedPupilIds.length} />&nbsp;&nbsp;&nbsp;
                                  <span className="checkbox-text">{Common.SelectAllStudents}</span>
                                </span>
                              </div>
                            </div>
                            <hr className="horizontal-line" />
                          </div>
                        )}
                        <input type="checkbox" onClick={(e) => { getPupilId(e); setPupilErr(false) }} value={item.id} checked={selectedPupilIds.includes(item.id)} />&nbsp;&nbsp;&nbsp;
                        <span className="pupil-name">{item.firstName + " " + item.lastName}</span>
                        <hr />
                      </>
                    )
                  })}
                  <div className="d-flex justify-content-between">
                    <div>
                      <button className="upload-cancel" type="button" onClick={() => { setUploadPage(!isUploadPage); setIsStudentModal(!isStudentModal); setIsStudentPage(false); setPupilErr(false) }}>{Common.Back}</button>&nbsp;
                    </div>
                    <div>
                      <button className="upload-button" type="submit">
                        <div className="d-flex justify-content-between ">
                          <span>{Common.Save}</span>
                          <img className="save-img" src={SaveButton} alt="SaveButton" />
                        </div>
                      </button>&nbsp;
                      <button className="upload-cancel" type="button" onClick={() => setIsOpen(false)}>{Common.Cancel}</button>
                    </div>
                  </div>
                  <br />
                  {pupilErr && (<small className="d-flex justify-content-between text-danger">{Common.PleaseSelectPupil}</small>)}
                </div>
              )
            }
          </form>
        )}
      </Formik>
    </React.Fragment>
  )
}

export { UploadEvidences }